import './scss/style.scss';
import './scss/variant-shu.scss';

import injectSVGSprite from './js/Util/InjectSVGSprite.js';
import ApplicationContext from './js/ApplicationContext.js';

// Import all images
require.context('./images', true, /.*/);

// Load the sprite into the DOM
const __svg__ = {path: './icons/**/*.svg', name: 'images/svg-sprite-[hash].svg'};
const url = __svg__.filename.indexOf('//') >= 0 ? __svg__.filename : '/resources/themes/sloepdelen/assets/' + __svg__.filename;
injectSVGSprite(url);

// Start the app
const context = new ApplicationContext();
context.start();


// WEBPACK FOOTER //
// ./frontend.js